const config = {
  API_ENDPOINT: 'https://morning-fortress-77195.herokuapp.com/api',
};

export default config;
